import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const check = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      try {
        const { data } = await http.post("/auth/refresh");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, check }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

// Retry once after refreshing the access token.
export async function authedGet(path) {
  try {
    return (await http.get(path)).data;
  } catch (e) {
    if (e.response?.status !== 401) throw e;
    await http.post("/auth/refresh");
    return (await http.get(path)).data;
  }
}
